export default __webpack_public_path__ + "static/media/photo--sm--matt-2.fc6ce22d.jpg";